
import NaxxumAuth from "../src/App.vue";
import storeAuth from "../src/store/index"
export default{
  install(Vue){
    Vue.component("NaxxumAuth", NaxxumAuth);
    Vue.prototype.$storeAuth = storeAuth

  }
  
};
